document.addEventListener('click', async function (e) {
    const btnModalEditarReferencia = e.target.closest('#btnModalEditarReferencia');
    if (!btnModalEditarReferencia) return;

    const idReferencia = btnModalEditarReferencia.getAttribute("data-id");
    const formEditar   = document.querySelector("#formEditarReferencia");
    const modalEditar  = document.querySelector("#ModalEditarReferencia");

    if (!formEditar || !idReferencia || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar la referencia.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/referencias/infoReferencia?idReferencia=${idReferencia}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información de la referencia.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputId        = formEditar.querySelector('#idReferenciaEditar');
        const inputCodigo    = formEditar.querySelector('#codigoSapEditarDisplay');
        const inputDescrip   = formEditar.querySelector('#descripSapEditarInput');
        const inputTipo      = formEditar.querySelector('#tipoReferenciaEditarInput');
        const inputPeso      = formEditar.querySelector('#pesoReferenciaEditarInput');
        const inputUnidadEmpaque = formEditar.querySelector('#unidadEmpaqueReferenciaEditarInput');
        const selectArea     = formEditar.querySelector('#areaReferenciaEditarInput');
        const divSwitch      = formEditar.querySelector('#divSwitchReferencia');

        if (inputId)      inputId.value      = data.idReferencia   || "";
        if (inputCodigo)  inputCodigo.value  = data.codigoSap      || "";
        if (inputDescrip) inputDescrip.value = data.descripSap     || "";
        if (inputTipo)    inputTipo.value    = data.idTipoReferencia  || "";
        if (inputPeso)    inputPeso.value    = data.peso            || "";
        if (inputUnidadEmpaque) inputUnidadEmpaque.value = data.unidadEmpaque || "";

        if (selectArea) {
            selectArea.value = data.idArea || "";
        }

        const checked     = Number(data.estadoReferencia) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoReferencia) === 1 ? 'ACTIVA'  : 'INACTIVA';

        divSwitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estadoReferencia"
                    value="${data.estadoReferencia}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información de la referencia:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información de la referencia.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarReferencia') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarReferencia');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar la referencia.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/referencias/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Referencia editada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
